import { createElement, type ReactNode } from 'react'
import { createRoot } from 'react-dom/client'
import { reportCaughtError } from '../../src/expected-render-error'
import { appRoot } from './mount-app-root'

export function mountApp(element: ReactNode | Promise<ReactNode>): void {
  const container = document.querySelector('#root')
  if (!container) throw new Error('Missing #root mount container')
  // A boundary rendering an expected unavailable state is not an error to log (@w/utils expected-render-error.ts).
  createRoot(container, { onCaughtError: reportCaughtError }).render(createElement(appRoot(element)))
}
